<template>
  <div id="app">
  <section id="sales_point" class="feature">
    <div class="feature-decor">
      <div class="feature-circle1"><img :src='"../../assets/images/feature2-blue.png"' alt=""></div>
    </div>
    <div class="container">
      <div class="row">
        <div class="feature-phone">
          <img :src='"../../assets/images/mockups/mainMockupLeft.png"' class="img-fluid" alt="">
        </div>
        <div class="offset-lg-4 col-lg-8">
          <div class="row">
            <div class="col-sm-12 mrgn-md-top">
              <h2 class="title">{{ $t(`offer.sales_point.title1`) }} <span>{{ $t(`offer.sales_point.title2`) }}</span></h2>
            </div>
            <div v-for="i in [1,2,3,4]" :key="i" class="col-12 col-md-6">
              <ul class="feature-style">
                <li class="abt-hover">
                  <div class="about-icon" style="left: 0px;  ">
                    <div class="icon-hover">
                      <img :src="getImgUrl(i)" alt="">
                    </div>
                  </div>
                  <div class="feature-subtitle" style="padding-left: 55px; padding-top: 3px">
                    <h3>{{ $t(`offer.sales_point.text.${i}.title`) }}</h3>
                  </div>
                  <div >
                    <p>{{ $t(`offer.sales_point.text.${i}.text`) }}</p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  </div>
</template>

<script>
export default {
  name: "SalesPoint",
  methods: {
    getImgUrl (image) {
      return require('../../assets/images/numbers/' + image + '.svg')
    },
  }
}
</script>

<style scoped>
@media only screen and (max-width: 768px) {
  .feature-style li {
    margin-bottom: 30px;
  }
  .feature-subtitle h3 {
    padding-bottom: 15px;
    padding-top: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/offerPage/sales_point.vue